import {BusinessUnit} from "./types/types";

export async function getSsoToken(): Promise<string> {
    try {
        return await Office.auth.getAccessToken({
            allowSignInPrompt: true,
            allowConsentPrompt: true,
            forMSGraphAccess: false,
        });
    } catch (err: any) {
        // Error codes: https://learn.microsoft.com/en-us/office/dev/add-ins/develop/troubleshoot-sso-in-office-add-ins
        console.error(`SSO failed: ${err.code} — ${err.message}`);
        throw err;
    }
}

export function truncate(input: string, max: number): string {
    return input.length > max ? input.slice(0, max) + "..." : input;
}

export function setDefaultBusinessUnit(value: BusinessUnit | null) {
    if (value == null) {
        localStorage.removeItem("defaultBusinessUnit");
        return;
    }
    localStorage.setItem("defaultBusinessUnit", value);
}

export function getDefaultBusinessUnit(): BusinessUnit | null {
    const value: string | null = localStorage.getItem("defaultBusinessUnit");
    if (value && BUSINESS_UNIT_MAP.hasOwnProperty(value)) return value as BusinessUnit;
    return null;
}

export const isDev: boolean = process.env.NODE_ENV === "development";
export const isProd: boolean = process.env.NODE_ENV === "production";

export interface BusinessUnitInfo {
    label: string;
    color: string;
}

export const BUSINESS_UNIT_MAP: Record<BusinessUnit, BusinessUnitInfo> = {
    DCTS: {label: "DCTS", color: "#2e9633"},
    JOBS: {label: "Jobs", color: "#2f76d3"},
    HOME_MAID: {label: "Home Maid", color: "#a8753d"},
};
